interface Company {
  name: string;
  registryCode: string;
  legalAddress: string;
  email: string;
  country: string;
}

export const company: Company = {
  name: 'InsideGallery OÜ',
  registryCode: '17243480',
  legalAddress: 'Järvevana tee 9, 11314 Tallinn, Estonia',
  email: 'info@inside.gallery',
  country: 'Estonia',
};
